export default {
  notification: {
    success: {
      disableSharing: 'Dashboard sharing has been disabled successfully.',
    },
  },
  label: {
    title: {
      addChart: 'Add component',
    },
    button: {
      addChart: 'Add',
    },
    chartPerPage: 'Total per page',
    searchCard: 'Search component',
  },
  dataType: {
    listening: 'Non-proprietary data',
    sac: 'Proprietary data',
    page: 'Page metrics',
    blip: 'BLIP',
    'sac-listening': 'Proprietary + Non-proprietary',
    custom: 'Custom',
    static: 'Complementary',
    'sac-status': 'Smart Care',
    mp: 'MP',
    sc: 'SC',
    contacts: 'Contacts',
    messages: 'Messages',
    'active-messages': 'Active messages',
    'event-track': 'Event log',
    'human-service': 'Human service',
  },
};
